import { SectionContainer, TeamCard } from '@/components/shared'
import { websiteContent } from '../content'
import { usePanelViewTracking } from '../hooks/usePanelViewTracking'

const { team } = websiteContent

function TeamSection() {
  usePanelViewTracking({
    panelId: 'team',
    panelName: 'Team',
    panelIndex: 5,
  })

  return (
    <SectionContainer
      id="team"
      size="page"
      className="bg-gray-lightest py-[56px] md:py-24"
      innerClassName="!px-10 md:!px-page-gutter xl:!px-content-inset 3xl:!px-content-inset-wide"
    >
      <div className="max-w-[313px] space-y-[56px] md:max-w-[802px] md:space-y-[72px]">
        <p className="font-archivo text-[12px] font-extralight uppercase leading-[16px] text-gray-dark">
          {team.title}
        </p>
        <h2 className="font-archivo text-[52px] font-extralight leading-[56px] text-black md:text-h1">
          {team.subtitle}
        </h2>
        <p className="font-archivo text-[18px] font-light leading-[32px] text-gray-dark md:text-h3">
          {team.description}
        </p>
      </div>

      <div className="mt-[56px] grid w-full max-w-[313px] gap-10 md:mt-[72px] md:max-w-[1156px] md:gap-[41px] md:grid-cols-2 lg:grid-cols-3 2xl:max-w-none 2xl:grid-cols-4">
        {team.members.map((member) => (
          <TeamCard
            key={member.name}
            name={member.name}
            role={member.role}
            imageSrc={member.image}
            linkedInUrl={member.linkedInUrl}
          />
        ))}
      </div>

      {/* TODO(nxt-phase2): Add the extra-members two-column roster list once final names and roles are approved. */}
    </SectionContainer>
  )
}

export default TeamSection
